import './modules/script';
import './modules/map/mapalex';

import AOS from 'aos';
// ..
AOS.init();
AOS.init({
  // Global settings:
  disable: false, // accepts following values: 'phone', 'tablet', 'mobile', boolean, expression or function
  startEvent: 'DOMContentLoaded', // name of the event dispatched on the document, that AOS should initialize on
  initClassName: 'aos-init', // class applied after initialization
  animatedClassName: 'aos-animate', // class applied on animation
  useClassNames: false, // if true, will add content of `data-aos` as classes on scroll
  disableMutationObserver: false, // disables automatic mutations' detections (advanced)
  debounceDelay: 50, // the delay on debounce used while resizing window (advanced)
  throttleDelay: 99, // the delay on throttle used while scrolling the page (advanced)


  // Settings that can be overridden on per-element basis, by `data-aos-*` attributes:
  offset: 120, // offset (in px) from the original trigger point
  delay: 0, // values from 0 to 3000, with step 50ms
  duration: 400, // values from 0 to 3000, with step 50ms
  easing: 'ease', // default easing for AOS animations
  once: false, // whether animation should happen only once - while scrolling down
  mirror: false, // whether elements should animate out while scrolling past them
  anchorPlacement: 'top-bottom', // defines which position of the element regarding to window should trigger the animation

});
AOS.init({
  disable: function() {
    var maxWidth = 767;
    return window.innerWidth < maxWidth;
  }
});


import LocomotiveScroll from 'locomotive-scroll';

const scroll = new LocomotiveScroll({
    el: document.querySelector('[data-scroll-container]'),
    smooth: true,
    getSpeed:true
});

if ($("body").is(".tax-product_cat, .woocommerce-shop")) {
  //scroll to top after woocommerce pagination click
  $(".woocommerce").on("click", ".woocommerce-pagination li", function(e) {
      if($(this).find('span').hasClass('current')){
      }else{
        var pageNum = $(this).find('a').attr('href');
        window.location.href = pageNum;
      }
  });
}

if($("#slider").length ){
    scroll.stop();
    var home_swipe= new Swiper(".home_swipe", {
        slidesPerView: 1,
        direction: 'horizontal',
        spaceBetween: 0,
        loop: false,
        speed: 1200,
        effect: "creative",
        creativeEffect: {
          prev: {
           translate: ["-50%", 0, -1],
          },
        next: {
         translate: ["100%", 0, 0],
        }
        },
        grabCursor: true,
        mousewheel: true,
    });
    home_swipe.on('reachBeginning', function(){
        scroll.stop();
    });
    home_swipe.on('reachEnd', function(){
        setTimeout(function() {scroll.start();}, 1200);
    });
  };


 $( document ).ready(function() {

    // $('.page-numbers').on('click', function() {
    //   const top = document.querySelector('#main');
    //   console.log('olll');
    //     scroll.scrollTo(top); 
    //   console.log('ollltt');
    // });

   new ResizeObserver(() => scroll.update()).observe(document.querySelector("[data-scroll-container]"));
    //sticky header
    if($('body').hasClass('page-template-tmpl_gallery') || $('body').hasClass('page-template-default') || $('body').hasClass('page-template-tmpl_contact')){
          $('.header_wrapper').addClass('pinned');
    }else{
      scroll.on('scroll',(instance)=>{
              if(instance.scroll.y > 300){
                  $('.header_wrapper').addClass('pinned');
              }else{
                $('.header_wrapper').removeClass('pinned');
              }
      });
    }

    var flag=1;// flag for text animation

    scroll.on('scroll', (args) => {
        // Get all current elements : args.currentElements
        if(typeof args.currentElements['imageanimation'] === 'object') {
            let progress = args.currentElements['imageanimation'].progress;
            if(progress>0.1){
              $('#imageright .main-cont .box_wrapper .left').addClass('animation');
            }else{
              $('#imageright .main-cont .box_wrapper .left').removeClass('animation');
            }
        }

        if(typeof args.currentElements['imageanimation2'] === 'object') {
            let progress = args.currentElements['imageanimation2'].progress;
            if(progress>0.1){
              $('#imageleft .main-cont .box_wrapper .left').addClass('animation');
            }else{
              $('#imageleft .main-cont .box_wrapper .left').removeClass('animation');
            }
        }

        if(typeof args.currentElements['lab'] === 'object') {
            let progress = args.currentElements['lab'].progress;
            if(progress>0.1){
              $('#lab .main-cont .box_wrapper .left').addClass('animation');
            }else{
              $('#lab .main-cont .box_wrapper .left').removeClass('animation');
            }
        }
        if(typeof args.currentElements['nature'] === 'object') {
            let progress = args.currentElements['nature'].progress;
            if(progress>0.1){
              $('#phytotherapy .main-cont .box_wrapper .right').addClass('animation');
            }else{
              $('#phytotherapy .main-cont .box_wrapper .right').removeClass('animation');
            }
        }

        if(typeof args.currentElements['parallax'] === 'object') {
            let progress = args.currentElements['parallax'].progress;
            var progress_new=(1.4-progress);
            var progress_new_y=(1.4-progress);
            if(progress_new <= 1){
              progress_new=1;
            }
            if(progress_new_y <= 1){
              progress_new_y=1;
            }
            $('#parallax .image').css('transform','scale('+ progress_new +','+ progress_new_y +')');
        }

        if(typeof args.currentElements['about'] === 'object') {
            let progress = args.currentElements['about'].progress;
            if(progress>0.2){
              //only do it once
              if(flag==1){
                flag=0;
                anime.timeline({loop: false})
                  .add({
                    targets: '.letters',
                    translateY: ["1.1em", 0],
                    opacity:1,
                    duration: 750,
                    delay: (el, i) => 60 * i
                  }).add({
                    targets: '.letters',
                    opacity: 1,
                    duration: 1000,
                    easing: "easeOutExpo",
                    delay: 1000
                  });
              }
            }
        }

        if(typeof args.currentElements['categories_inner'] === 'object') {
            let progress = args.currentElements['categories_inner'].progress;
            var progress_new=(progress+0.88);
            var progress_new_y=(progress+0.8);
            if(progress_new >= 1){
              progress_new=1;
            }
            if(progress_new_y >= 1){
              progress_new_y=1;
            }
            //if(progress>0.1){
                $('#categories_inner').css('transform','scale('+ progress_new +','+ progress_new_y +')');
          //  }
        }

        if(typeof args.currentElements['map'] === 'object') {
            let progress = args.currentElements['map'].progress;
            var progress_new=(progress+0.88);
            var progress_new_y=(progress+0.8);
            if(progress_new >= 1){
              progress_new=1;
            }
            if(progress_new_y >= 1){
              progress_new_y=1;
            }
            //if(progress>0.1){
                $('#map').css('transform','scale('+ progress_new +','+ progress_new_y +')');
          //  }
        }

    });

 });
